import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [accessToken, setAccessToken] = useState(localStorage.getItem("spotify_access_token") || "");
    const [tokenExpiry, setTokenExpiry] = useState(parseInt(localStorage.getItem("spotify_token_expiry"), 10) || 0);

    const refreshToken = async () => {
        try {
            const response = await fetch("https://accounts.spotify.com/api/token", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams({
                    grant_type: "refresh_token",
                    refresh_token: "AQD_TiH3XHIR0nO8QtHYRCWdQLURYk-1tunFNew9Q8M8JUlX2IVlmWEK3TWVGQ6-vDV71dkrYvO1KnGsJ5-cpRmbIlXmJ0nd77sG9TXlxqKVd12-aE2MimPFdZHPh_E6Y1k",
                    client_id: "adb3964dd1db4af0b81a9e7697db2605",
                    client_secret: "275f587454c54b669eeef7eba7373a0b"
                }),
            });

            const data = await response.json();
            if (data.access_token) {
                setAccessToken(data.access_token);
                setTokenExpiry(Date.now() + data.expires_in * 1000);
                localStorage.setItem("spotify_access_token", data.access_token);
                localStorage.setItem("spotify_token_expiry", Date.now() + data.expires_in * 1000);
            }
        } catch (error) {
            console.error("Error refreshing token:", error);
        }
    };

    useEffect(() => {
        if (!accessToken || Date.now() > tokenExpiry) {
            refreshToken();
        }
        const interval = setInterval(() => {
            if (Date.now() > tokenExpiry) refreshToken();
        }, 1000 * 60 * 55); // Her 55 dakikada bir yenile
        return () => clearInterval(interval);
    }, [accessToken, tokenExpiry]);

    return (
        <AuthContext.Provider value={{ accessToken }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
